// extracted by mini-css-extract-plugin
export default {"video-link":"j_C d-flex align-items-center my-2","video-link__link":"j_D ml-2"};